import { WatcherType } from "../types/watcherType";

export const watcherSaveForLayoffsFund = (props : WatcherType) => {
    const { watcher, currentStep, fields  } = props;
        let process =  [...fields];
        process = process.map((section, idx) => {
                if (!section.fields || idx !== currentStep) return section
                let fields = [
                    ...section?.fields.map((field: any) => {
                        if (
                            field.name === "afiliationLayoffsFund" 
                        ) {
                            return { ...field, hidden: true };
                        }
                        return field;
                    }),
                ];
                if (watcher === "SÍ") {
                    fields = fields.map((field: any) => {
                        if (field.name === "afiliationLayoffsFund") {
                            return { ...field, hidden: false };
                        }
                        return field;
                    });
                }
                if (watcher === "NO") {
                    fields = fields.map((field: any) => {
                        if (field.name === "afiliationLayoffsFund") {
                            return { ...field, hidden: true };
                        }
                        return field;
                    });
                }
                
                return { ...section, fields };
            }
        );

        return process;
};
